import { useSearchParams } from 'react-router-dom'
import { Element } from '../../../common/html/element'
import { Icon } from '../../../common/html/icon'

export const EditCell = ({ rowId }) => {
  const setSearchParams = useSearchParams()[1]

  const handleClick = () => {
    setSearchParams({ profileId: rowId })
  }

  return (
    <Element onClick={handleClick}>
      <Icon
        className="icon-open-new"
        style={{ color: '#006AA6', fontSize: 15 }}
      />
    </Element>
  )
}
